import Vue from 'vue'
import Router from 'vue-router'

import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '@/components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
import Widgets from 'src/components/Dashboard/Views/Dashboard/Widgets.vue'

// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
//import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'

// APP PAGES 

import Account from '@/components/App/Account'
import Signup from '@/components/App/Signup'
import Login from '@/components/App/Login'
import EmailVerify from '@/components/App/EmailVerify'
import EmailUpdate from '@/components/App/EmailUpdate'
import Dashboard from '@/components/App/Dashboard'
import DashboardClient from '@/components/App/DashboardClient'
import UserConfirm from '@/components/App/UserConfirm'
import ProfileCreate from '@/components/App/ProfileCreate'
import ProfileUpdate from '@/components/App/ProfileUpdate'
import ProfileClientCreate from '@/components/App/ProfileClientCreate'
import ProfileClientUpdate from '@/components/App/ProfileClientUpdateNew'
import PasswordUpdate from '@/components/App/PasswordUpdate'
import PasswordForgot from '@/components/App/PasswordForgot'
import PasswordReset from '@/components/App/PasswordReset'
import Confirmation from '@/components/App/Confirmation'
import Categories from '@/components/App/Categories'
import DashboardSales from '@/components/App/DashboardSales'
import DashboardInfluencers from '@/components/App/DashboardInfluencers'
import DashboardContent from '@/components/App/DashboardContent'
import Leads from '@/components/App/Leads'
import Clients from '@/components/App/Clients'
import ClientDetail from '@/components/App/ClientDetail'
import ClientJoin from '@/components/App/ClientJoin'
import LeadDetail from '@/components/App/LeadDetail'
import EngagementProfiles from '@/components/App/EngagementProfiles'
import EngagementProfileEdit from '@/components/App/EngagementProfileEdit'
import EngagementCandidates from '@/components/App/EngagementCandidates'
import InfluencerCampaignCreate from '@/components/App/InfluencerCampaignCreate'
import InfluencerCampaignEdit from '@/components/App/InfluencerCampaignEdit'
import InfluencerCampaignDetail from '@/components/App/InfluencerCampaignDetail'
import InfluencerCampaignList from '@/components/App/InfluencerCampaignList'
import InfluencerCampaignListClient from '@/components/App/InfluencerCampaignListClient'
import Earnings from '@/components/App/views/Earnings'
import CampaignContentsBrandList from '@/components/App/views/CampaignContents/Brand/list'
import CampaignContentsBrandDetail from '@/components/App/views/CampaignContents/Brand/detail'
import CampaignContentsInfluencerList from '@/components/App/views/CampaignContents/Influencer/list'
import CampaignContentsInfluencerDetail from '@/components/App/views/CampaignContents/Influencer/detail'
import InfluencerCampaignManage from '@/components/App/InfluencerCampaignManage'
import InfluencerCandidateDetail from '@/components/App/InfluencerCandidateDetail'
import InfluencerCandidateDetailClient from '@/components/App/InfluencerCandidateDetailClient'
import InfluencerCandidateList from '@/components/App/InfluencerCandidateList'
import InfluencerDiscountList from '@/components/App/InfluencerDiscountList'
import InfluencerCampaignAnalytics from '@/components/App/InfluencerCampaignAnalytics'
import InfluencerCollaborationList from '@/components/App/InfluencerCollaborationList'
import InfluencerCollaborationDetail from '@/components/App/InfluencerCollaborationDetail'
import InfluencerPostSearch from '@/components/App/InfluencerPostSearch'
//import InfluencerContent from '@/components/App/InfluencerContent'
import InstagramPostList from '@/components/App/InstagramPostList'
import InstagramPostDetail from '@/components/App/InstagramPostDetail'
import InstagramPostDownload from '@/components/App/InstagramPostDownload'
import InfluencerJoin from '@/components/App/InfluencerJoin'
import InstagramSearch from '@/components/App/InstagramSearch'
import InstagramHashtagSearch from '@/components/App/InstagramHashtagSearch'
import InstagramContentSearch from '@/components/App/InstagramContentSearch'
import InstagramDetails from '@/components/App/InstagramDetail'
import InstagramAnalytics from '@/components/App/InstagramAnalytics'
import InstagramAnalyticsContent from '@/components/App/InstagramAnalyticsContent'
import InstagramAnalyticsFeed from '@/components/App/InstagramAnalyticsFeed'
import DiscountCodeDetails from '@/components/App/DiscountCodeDetails'
import TrackingLinks from '@/components/App/TrackingLinks'
import TrackingLinkAnalytics from '@/components/App/TrackingLinkAnalytics'
import ShopifyOrderAnalytics from '@/components/App/ShopifyOrderAnalytics'
import ShopifyConfirm from '@/components/App/ShopifyConfirm'
import DiscountCodeList from '@/components/App/DiscountCodeList'
import AdSearch from '@/components/App/AdSearch'
import AdDetail from '@/components/App/AdDetail'
import FbAuth from '@/components/App/FbAuth'
import ShopifyAuth from '@/components/App/ShopifyAuth'
import FbAuthTest from '@/components/App/FbAuthTest'
import firebase from 'firebase'
import store from '@/store/index.js'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'



// Forms pages
import RegularForms from 'src/components/Dashboard/Views/Forms/RegularForms.vue'
import ExtendedForms from 'src/components/Dashboard/Views/Forms/ExtendedForms.vue'
import ValidationForms from 'src/components/Dashboard/Views/Forms/ValidationForms.vue'
import Wizard from 'src/components/Dashboard/Views/Forms/Wizard.vue'

// TableList pages
import RegularTables from 'src/components/Dashboard/Views/Tables/RegularTables.vue'
import ExtendedTables from 'src/components/Dashboard/Views/Tables/ExtendedTables.vue'
import PaginatedTables from 'src/components/Dashboard/Views/Tables/PaginatedTables.vue'
// Maps pages
import GoogleMaps from 'src/components/Dashboard/Views/Maps/GoogleMaps.vue'
import FullScreenMap from 'src/components/Dashboard/Views/Maps/FullScreenMap.vue'
import VectorMaps from 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue'

// Calendar
import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// Charts
import Charts from 'src/components/Dashboard/Views/Charts.vue'

Vue.use(Router)

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [{
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ]
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [{
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ]
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [{
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }
  ]
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [{
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}

/*let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [{
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}*/


let influencerCampaignPages = {
  path: '/influencer-campaign',
  name: 'InfluencerCampaign',
  component: DashboardLayout,
  children: [

    {
      path: 'create',
      name: 'InfluencerCampaignCreate',
      component: InfluencerCampaignCreate,

    },
    {
      path: 'edit/:campaignId',
      name: 'InfluencerCampaignEdit',
      component: InfluencerCampaignEdit,

    },
    {
      path: 'details/:campaignId',
      name: 'InfluencerCampaignDetail',
      component: InfluencerCampaignDetail,

    },
    {
      path: 'analytics/:campaignId',
      name: 'InfluencerCampaignAnalytics',
      component: InfluencerCampaignAnalytics,

    },
    {
      path: 'list',
      name: 'InfluencerCampaignList',
      component: InfluencerCampaignList
    },
    {
      path: 'list/:campaignId',
      name: 'InfluencerCandidateList',
      component: InfluencerCandidateList,

    },
    {
      path: 'codes/:campaignId',
      name: 'InfluencerDiscountList',
      component: InfluencerDiscountList,

    }, {
      path: 'manage/:campaignId',
      name: 'InfluencerCampaignManage',
      component: InfluencerCampaignManage,

    },
    {
      path: 'list/:campaignId',
      name: 'InfluencerCandidateList',
      component: InfluencerCandidateList,

    },
    {
      path: 'candidate/:candidateId',
      name: 'InfluencerCandidateDetail',
      component: InfluencerCandidateDetail,

    },
    {
      path: 'influencer/:candidateId',
      name: 'InfluencerCandidateDetailClient',
      component: InfluencerCandidateDetailClient,
    },
    {
      path: 'post/search/:campaignId',
      name: 'InfluencerPostSearch',
      component: InfluencerPostSearch,
    },
    {
      path: 'content-list/:campaignId/:candidateId',
      name: 'CampaignContentsBrandList',
      component: CampaignContentsBrandList,
    },
    {
      path: 'content-detail/:contentId',
      name: 'CampaignContentsBrandDetail',
      component: CampaignContentsBrandDetail,
    }
  ],
  meta: {
    requiresAuth: true
  }
}
let influencerCandidatePages = {
  path: '/influencer',
  name: 'Influencer',
  component: DashboardLayout,
  children: [

    {
      path: 'collaborations/:instagramId',
      name: 'InfluencerCollaborationList',
      component: InfluencerCollaborationList,

    },
    {
      path: 'collaboration/detail/:candidateId',
      name: 'InfluencerCollaborationDetail',
      component: InfluencerCollaborationDetail,

    },
    {
      path: 'collaboration/detail/content-list/:candidateId/:campaignId',
      name: 'CampaignContentsInfluencerList',
      component: CampaignContentsInfluencerList,
    },
    {
      path: 'collaboration/content-detail/:contentId',
      name: 'CampaignContentsInfluencerDetail',
      component: CampaignContentsInfluencerDetail,
    }
    /* {
       path: 'content/:influencerId',
       name: 'InfluencerContent',
       component: InfluencerContent,

     }*/
  ],
  meta: {
    requiresAuth: true
  }
}

let influencerEarnings = {
  path: '/influencer',
  name: 'InfluencerEarnings',
  component: DashboardLayout,
  children: [
    {
      path: 'earnings',
      name: 'Earnings',
      component: Earnings
    },
  ],
  meta: {
    requiresAuth: true
  }
}

let toolsPages = {
  path: '/tools',
  name: 'Tools',
  component: DashboardLayout,
  children: [{
      path: 'tracking-links/analytics/:linkId',
      name: 'TrackingLinkAnalytics',
      component: TrackingLinkAnalytics,

    },
    {
      path: 'tracking-links/:userType/:accountId',
      name: 'TrackingLinks',
      component: TrackingLinks,
    }

  ],
  meta: {
    requiresAuth: true
  }
}

let instagramSearchPages = {
  path: '/instagram',
  name: 'InstagramSearch',
  component: DashboardLayout,
  children: [{
      path: 'search',
      name: 'InstagramSearch',
      component: InstagramSearch,
    },
    {
      path: 'details',
      name: 'InstagramDetails',
      component: InstagramDetails,
    },
    {
      path: 'content/:instagram',
      name: 'InstagramPostList',
      component: InstagramPostList,
    },
    {
      path: 'post/:shortcode',
      name: 'InstagramPostDetail',
      component: InstagramPostDetail,
    },
    {
      path: 'download/:shortcode',
      name: 'InstagramPostDownload',
      component: InstagramPostDownload,
    },
    {
      path: 'analytics/all/:instagram',
      name: 'InstagramAnalytics',
      component: InstagramAnalytics,
    },
    {
      path: 'analytics/content/:instagram',
      name: 'InstagramAnalyticsContent',
      component: InstagramAnalyticsContent,
    },
    {
      path: 'analytics/feed/:instagram',
      name: 'InstagramAnalyticsFeed',
      component: InstagramAnalyticsFeed,
    },
    {
      path: 'search/hashtags',
      name: 'InstagramSearchHashtag',
      component: InstagramHashtagSearch,
    },
    {
      path: 'search/content',
      name: 'InstagramContentSearch',
      component: InstagramContentSearch,
    }
  ],
  meta: {
    requiresAuth: true
  }
}

let clientManagePages = {
  path: '/client',
  name: 'InstagramSearch',
  component: DashboardLayout,
  children: [{
      path: 'create',
      name: 'ClientCreate',
      component: ProfileClientCreate,
    },
    {
      path: 'update/:clientId',
      name: 'ClientUpdate',
      component: ProfileClientUpdate,

    },
    {
      path: 'list',
      name: 'Clients',
      component: Clients,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'detail/:clientId',
      name: 'ClientDetail',
      component: ClientDetail,

    },
    {
      path: 'influencer-campaigns/:clientId',
      name: 'InfluencerCampaignListClient',
      component: InfluencerCampaignListClient,

    },

  ],
  meta: {
    requiresAuth: true
  }
}
let profilePages = {
  path: '/profile',
  name: 'Profile',
  component: DashboardLayout,
  children: [{
    path: 'update',
    name: 'ProfileUpdate',
    component: ProfileUpdate,
  }, {
    path: '/create-profile',
    name: 'ProfileCreate',
    component: ProfileCreate,
  }],
  meta: {
    requiresAuth: true
  }
}

let salesPages = {
  path: '/sales',
  name: 'Sales',
  component: DashboardLayout,
  children: [{
      path: 'ad-search',
      name: 'AdSearch',
      component: AdSearch,
    },
    {
      path: 'ad-detail/:shortcode',
      name: 'AdDetail',
      component: AdDetail,
    }
  ],
  meta: {
    requiresAuth: true
  }
}

let shopifyPages = {
  path: '/shopify',
  name: 'ShopifyOrders',
  component: DashboardLayout,
  children: [{
    path: 'orders/:shop',
    name: 'ShopifyOrderAnalytics',
    component: ShopifyOrderAnalytics,
  }, {
    path: 'discounts/:shop',
    name: 'DiscountCodeList',
    component: DiscountCodeList,
  }, {
    path: 'discounts/details/:discountId',
    name: 'DiscountCodeDetails',
    component: DiscountCodeDetails,
  }, {
    path: 'confirm',
    name: 'Shopify Confirm',
    component: ShopifyConfirm
  }],
  meta: {
    requiresAuth: true
  }
}
let accountPages = {
  path: '/account',
  name: 'Account',
  component: DashboardLayout,
  children: [{
    path: 'active-instagram',
    name: 'Instagram Auth',
    component: FbAuth
  }, {
    path: 'active-instagram-test',
    name: 'Instagram Auth',
    component: FbAuthTest
  }, {
    path: 'active-shopify/:clientId',
    name: 'Shopify Auth',
    component: ShopifyAuth
  }],
  meta: {
    requiresAuth: true
  }
}

let dashboardPages = {
  path: '/dashboard',
  name: 'Dashboard',
  component: DashboardLayout,
  children: [{
    path: 'client/:clientId',
    name: 'DashboardClient',
    component: DashboardClient
  }, {
    path: '',
    name: 'Dashboard',
    component: Dashboard
  }],
  meta: {
    requiresAuth: true
  }
}


let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  //componentsMenu,
  //formsMenu,
  //tablesMenu,
  //mapsMenu,
  //pagesMenu,
  influencerCampaignPages,
  instagramSearchPages,
  clientManagePages,
  influencerCampaignPages,
  profilePages,
  accountPages,
  influencerCandidatePages,
  influencerEarnings,
  toolsPages,
  dashboardPages,
  salesPages,
  shopifyPages,

  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
  },

  // loginPage,
  registerPage,
  lockPage,
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [{
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets
      }
    ]
  },
  {
    path: '*',
    component: NotFound
  },

  // IMPORTED FROM APP 
  {
    path: '/profile',
    name: 'Profile',
    component: ProfileUpdate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dashboard/influencers',
    name: 'DashboardInfluencers',
    component: DashboardInfluencers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sales-dashboard',
    name: 'DashboardSales',
    component: DashboardSales,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/content-dashboard',
    name: 'DashboardContent',
    component: DashboardContent,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/email-change',
    name: 'EmailUpdate',
    component: EmailUpdate
  },
  /*{
    path: '/create-profile',
    name: 'ProfileCreate',
    component: ProfileCreate,
    meta: {
      requiresAuth: true
    }
  },*/
  {
    path: '/login',
    name: 'Login',
    component: Login,
    /*meta: {
      requiresGuest: true
    }*/
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/email-verify',
    name: 'EmailVerify',
    component: EmailVerify,

    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user-confirm',
    name: 'UserConfirm',
    component: UserConfirm
  },
  {
    path: '/password-change',
    name: 'PasswordUpdate',
    component: PasswordUpdate
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: PasswordReset
  },
  {
    path: '/password-forgot',
    name: 'PasswordForgot',
    component: PasswordForgot
  },
  {
    path: '/confirmation',
    name: 'Confirmation',
    component: Confirmation
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/categories',
    name: 'Categories',
    component: Categories,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/leads/:categoryId',
    name: 'Leads',
    component: Leads,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/leads/detail/:leadId',
    name: 'LeadDetail',
    component: LeadDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/engagement/profiles',
    name: 'EngagementProfiles',
    component: EngagementProfiles,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/engagement/candidates/:profileName',
    name: 'EngagementCandidates',
    component: EngagementCandidates,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/engagement/profile/:profileName',
    name: 'EngagementProfileEdit',
    component: EngagementProfileEdit,
    meta: {
      requiresAuth: true
    }
  },


  {
    path: '/influencer/join/:candidateId',
    name: 'InfluencerJoin',
    component: InfluencerJoin

  },

  {
    path: '/client/join/:inviteId',
    name: 'ClientJoin',
    component: ClientJoin
  },
  {
    path: '/facebook',
    name: 'FacebookAuth',
    component: DashboardLayout,
    children: [{
      path: 'auth',
      name: 'Instagram Auth',
      component: FbAuth
    }],
    meta: {
      requiresAuth: true
    }
  }
];

let router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

// NAV GUARDS 

router.beforeEach((to, from, next) => {

  // CHECK FOR REQUIRED AUTH GUARD
  //console.log("THIS IS THE TO:", to)


  if (to.matched.some(record => record.meta.requiresAuth)) {
    // CHECK TO SEE IF NOT LOGGED IN

    if (!firebase.auth().currentUser) {
      // GO TO LOGIN PAGE 

      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else if (firebase.auth().currentUser.emailVerified === false) {
      //console.log("VERIFYING EMAIL")
      //console.log("")
      if (to.path !== '/email-verify') {
        next({
          path: '/email-verify'
        })
      } else {
        next()
      }

    } else if (to.path === '/create-profile') {

      if (firebase.auth().currentUser.displayName != null) {
        next({
          path: '/profile'
        })
      } else {
        next()
      }

    } else if (firebase.auth().currentUser.displayName === 'undefined' || firebase.auth().currentUser.displayName === null) {
      // PROCEED TO ROUTE 
      //console.log("GOING TO NEXT ROUTE")

      next({
        path: '/create-profile'
      })

    } else {
      //console.log("PASSES CHECKS....")
      //console.log("GOING TO:", to.path)
      //console.log("DISPLAY SET:", firebase.auth().currentUser.displayName)
      next()
    }

  } else if (to.matched.some(record => record.meta.requiresGuest)) {

    // CHECK IF LOGGED IN
    if (firebase.auth().currentUser) {

      // GO TO LOGIN PAGE 
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })

    } else {
      // PROCEED TO ROUTE 
      //console.log("POSITION 0 ")
      next();
    }
  } else {
    // PROCEED TO ROUTE 
    //console.log("POSITION 1 ")
    //console.log("HERE IS THE FULL PATH:", to.fullPath)
    next();
  }

})

export default router;